export default "__VITE_ASSET__CYGuB5ij__"